import React from 'react';
import { Box, Typography } from '@mui/material';

const HowToEvaluateSoftwareArticle = () => (
    <Box>
        <Typography variant="h3" component="h1" fontWeight={700} gutterBottom sx={{ fontSize: { xs: '1.65rem', md: '2rem' } }}>
            How to Evaluate Software for Field-Based Therapy Teams
        </Typography>
        <Typography color="text.secondary" paragraph>
            Most platforms will show you scheduling and notes. Fewer will show you verified visits, field accountability, and
            payout accuracy.{" "}
            {"Here's how to tell the difference before you commit."}
        </Typography>
        <Typography variant="h2" component="h2" fontWeight={700} sx={{ fontSize: '1.35rem', mt: 4, mb: 1.5 }}>
            Scheduling and notes are table stakes
        </Typography>
        <Typography color="text.secondary" paragraph>
            Almost every vendor will demo a calendar and a note template. Ask what happens after the therapist leaves the
            patient’s home: how the visit is confirmed, how exceptions are visible to admin, and how documentation is enforced
            before the therapist moves on. If the answer is “they submit it later,” you still have a reconciliation problem at
            month-end.
        </Typography>
        <Typography variant="h2" component="h2" fontWeight={700} sx={{ fontSize: '1.35rem', mt: 4, mb: 1.5 }}>
            Verified visits and field accountability
        </Typography>
        <Typography color="text.secondary" paragraph>
            Look for a clear model of who delivered care, where, and when—captured in a way that does not depend entirely on
            self-report after the fact. Ask how supervisors or ops see coverage across the city, and how you would answer a
            payout or claim question with evidence rather than a thread of messages.
        </Typography>
        <Typography variant="h2" component="h2" fontWeight={700} sx={{ fontSize: '1.35rem', mt: 4, mb: 1.5 }}>
            Payout traceability
        </Typography>
        <Typography color="text.secondary" paragraph>
            Follow the money in the demo. Can you see the path from completed visits to the number that should appear on a
            therapist’s payout? If there is a manual consolidation step in between, disputes will still land on your desk—you
            will just have a nicer UI around the same problem.
        </Typography>
        <Typography color="text.secondary" paragraph>
            Before you sign, insist on clarity on those three dimensions: verification, accountability, and payout accuracy.
            That is how you tell whether a platform is built for field-based therapy or adapted to sound like it.
        </Typography>
    </Box>
);

export default HowToEvaluateSoftwareArticle;
